export default "__VITE_ASSET__CHyqzWdO__"